import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import {
  createOrder,
  isLoadingOrderSelector,
  selectedOrderSelector,
  setSelectedOrder,
} from 'src/store/orders';

import { CustomButton, PageLoader, WhiteCard } from 'src/components';

import { WarningIcon } from 'src/assets';
import './acceptExchange.scss';
import { ROUTE } from 'src/constants';

export const AcceptExchange = () => {
  const { t } = useTranslation('acceptExchange');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedOrder = useSelector(selectedOrderSelector);
  const isLoadingOrder = useSelector(isLoadingOrderSelector);

  useEffect(() => {
    if (_.isEmpty(selectedOrder)) {
      navigate(-1);
    }
  }, [navigate, selectedOrder]);

  const renderItem = useCallback(
    (text, value, key) => {
      return (
        <div className="accept-exchange__item" key={key}>
          <div className="accept-exchange__item__text">{key ? text : t(text)}</div>
          <h5>{value}</h5>
        </div>
      );
    },
    [t],
  );

  const onClickCreateOrder = useCallback(() => {
    const payload = { navigate, payload: selectedOrder };

    dispatch(createOrder(payload));
  }, [dispatch, navigate, selectedOrder]);

  const onClickCancel = useCallback(() => {
    dispatch(setSelectedOrder({}));
    navigate(ROUTE.HOME);
  }, [dispatch, navigate]);

  const currencyGiven = selectedOrder?.currencyGiven;
  const currencyReceived = selectedOrder?.currencyReceived;

  return (
    <div className="accept-exchange">
      {isLoadingOrder ? <PageLoader /> : null}

      <WhiteCard>
        <h2>{t('accept')}</h2>
        <div className="accept-exchange__content">
          <WhiteCard>
            <h5>{t('checkData')}</h5>
            {renderItem(
              'createExchange:give',
              `${selectedOrder?.given_sum} ${currencyGiven?.name} (${currencyGiven?.code})`,
            )}
            {renderItem(
              'createExchange:receive',
              `${selectedOrder?.received_sum} ${currencyReceived?.name} (${currencyReceived?.code})`,
            )}
            {selectedOrder?.fields?.map((item) =>
              renderItem(item?.translate || 'Translate don`t exist', item?.name, item?.field),
            )}
            <div className="accept-exchange__content__footer">
              <CustomButton
                variant="filled"
                color="red"
                title={t('title:cancelRequest')}
                onClick={onClickCancel}
              />
              <CustomButton
                variant="filled"
                title={t('title:createRequest')}
                onClick={onClickCreateOrder}
              />
            </div>
          </WhiteCard>
          <div className="accept-exchange__warning__wrapper">
            <div className="accept-exchange__warning">
              <div>
                <img src={WarningIcon} alt={WarningIcon} />
              </div>
              {t('warning')}
            </div>
          </div>
        </div>
      </WhiteCard>
    </div>
  );
};
